module.exports = __webpack_public_path__ + "img/WxCode.e4b56674.png";